module.exports = __webpack_public_path__ + "static/media/van.4a83190b.jpg";